import React, { Component, Fragment } from "react";
import { Row, Col } from "reactstrap";
import Circle from "react-circle";
import * as ServerService from "../../../../services/server/api_server";

function boxMullerRandom() {
  let phase = false,
    x1,
    x2,
    w;

  return (function() {
    if ((phase = !phase)) {
      do {
        x1 = 2.0 * Math.random() - 1.0;
        x2 = 2.0 * Math.random() - 1.0;
        w = x1 * x1 + x2 * x2;
      } while (w >= 1.0);

      w = Math.sqrt((-2.0 * Math.log(w)) / w);
      return x1 * w;
    } else {
      return x2 * w;
    }
  })();
}

class ServerDetails extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);

    this.state = {
      data: [],
      serverOS: {},
      loadingServerOS: true,
      serverDisk: {},
      loadingServerDisk: true,
      dropdownOpen: false
    };

    setInterval(() => {
      if (this._isMounted) {
        this.setState({
          data: this.state.data.concat([boxMullerRandom()])
        });
      }
    });
  }

  /*********************************** LIFECYCLE ***********************************/
  componentDidMount() {
    this._isMounted = true;

    this.refreshData();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }
  /*********************************** LIFECYCLE ***********************************/

  refreshData() {
    // Call endpoints:
    this.getServerOSDetails();
    this.getServerDiskDetails();
  }

  async getServerOSDetails() {
    /**
     * Get Server Details from server:
     * pending > resolved (success) OR rejected (failure)
     */
    const promise = ServerService.getOSDetails();
    const jsonResponse = await promise;
    const { data } = jsonResponse;

    if (data !== undefined && this._isMounted) {
      //console.log("### DATA: ", data);
      const newState = { ...this.state };
      newState.serverOS = data;
      newState.loadingServerOS = false;
      this.setState(newState);
    }
  }

  async getServerDiskDetails() {
    /**
     * Get Server Details from server:
     * pending > resolved (success) OR rejected (failure)
     */
    const promise = ServerService.getDiskDetails();
    const jsonResponse = await promise;
    const { data } = jsonResponse;

    //console.log("### DISK: ", data);

    if (data !== undefined && this._isMounted) {
      const newState = { ...this.state };
      newState.serverDisk = data;
      newState.loadingServerDisk = false;
      this.setState(newState);
    }
  }

  toggle() {
    if (this._isMounted) {
      this.setState(prevState => ({
        dropdownOpen: !prevState.dropdownOpen
      }));
    }
  }

  onMouseEnter() {
    if (this._isMounted) {
      this.setState({ dropdownOpen: true });
    }
  }

  onMouseLeave() {
    if (this._isMounted) {
      this.setState({ dropdownOpen: false });
    }
  }

  render() {
    return (
      <Fragment>
        <h3 className="drawer-heading">Servers Status</h3>
        <div className="drawer-section">
          <Row>
            <Col>
              <div className="progress-box">
                <h4>CPU</h4>
                <Circle
                  animate={true} // Boolean: Animated/Static progress
                  animationDuration="8s" // String: Length of animation
                  responsive={true} // Boolean: Make SVG adapt to parent size
                  size="80" // String: Defines the size of the circle.
                  lineWidth="25" // String: Defines the thickness of the circle's stroke.
                  progress={
                    this.state.serverOS.cpuUsage
                      ? parseInt(this.state.serverOS.cpuUsage * 100, 10)
                      : 0
                  } // String: Update to change the progress and percentage.
                  progressColor="#f7b924" // String: Color of "progress" portion of circle.
                  bgColor="#f3f5f2" // String: Color of "empty" portion of circle.
                  textColor="#bcbebf" // String: Color of percentage text color.
                  /* textStyle={{
                                         font: 'bold 4rem Helvetica, Arial, sans-serif' // CSSProperties: Custom styling for percentage.
                                     }}*/
                  percentSpacing={10} // Number: Adjust spacing of "%" symbol and number.
                  roundedStroke={true} // Boolean: Rounded/Flat line ends
                  showPercentage={true} // Boolean: Show/hide percentage.
                  showPercentageSymbol={true} // Boolean: Show/hide only the "%" symbol.
                />
              </div>
            </Col>
            <Col>
              <div className="progress-box">
                <h4>Memory</h4>
                <Circle
                  animate={true} // Boolean: Animated/Static progress
                  animationDuration="6s" // String: Length of animation
                  responsive={true} // Boolean: Make SVG adapt to parent size
                  size="80" // String: Defines the size of the circle.
                  lineWidth="25" // String: Defines the thickness of the circle's stroke.
                  progress={
                    this.state.serverOS.freememPercentage
                      ? 100 -
                        parseInt(this.state.serverOS.freememPercentage * 100, 10)
                      : 0
                  } // String: Update to change the progress and percentage.
                  progressColor="#3ac47d" // String: Color of "progress" portion of circle.
                  bgColor="#f3f5f2" // String: Color of "empty" portion of circle.
                  textColor="#bcbebf" // String: Color of percentage text color.
                  /* textStyle={{
                                         font: 'bold 4rem Helvetica, Arial, sans-serif' // CSSProperties: Custom styling for percentage.
                                     }}*/
                  percentSpacing={10} // Number: Adjust spacing of "%" symbol and number.
                  roundedStroke={true} // Boolean: Rounded/Flat line ends
                  showPercentage={true} // Boolean: Show/hide percentage.
                  showPercentageSymbol={true} // Boolean: Show/hide only the "%" symbol.
                />
              </div>
            </Col>
            <Col>
              <div className="progress-box">
                <h4>Details</h4>
                <p style={{ marginTop: "14px" }}>
                  Num CPUs:
                  <br />
                  <b>
                    {this.state.serverOS.cpuCount
                      ? this.state.serverOS.cpuCount
                      : "0"}
                  </b>
                </p>
                <p>
                  Total Mem:
                  <br />
                  <b>
                    {this.state.serverOS.totalmem
                      ? this.state.serverOS.totalmem
                      : "0"}{" "}
                    MB
                  </b>
                </p>
              </div>
            </Col>
          </Row>

          <div className="divider" />

          <div className="mt-3">
            <p>
              <b>CPU: </b>
              {this.state.serverOS.cpu &&
              this.state.serverOS.cpu[0] &&
              this.state.serverOS.cpu[0].model
                ? this.state.serverOS.cpu[0].model
                : ""}
            </p>
            <p>
              <b>Platform: </b>
              {this.state.serverOS.platform ? this.state.serverOS.platform : ""}
            </p>
            <p>
              <b>Load Average (1 min): </b>
              {this.state.serverOS.loadavg &&
              this.state.serverOS.loadavg["1"] !== undefined
                ? this.state.serverOS.loadavg["1"]
                : ""}
            </p>
            <p>
              <b>Load Average (5 min): </b>
              {this.state.serverOS.loadavg &&
              this.state.serverOS.loadavg["5"] !== undefined
                ? this.state.serverOS.loadavg["5"]
                : ""}
            </p>
            <p>
              <b>Load Average (15 min): </b>
              {this.state.serverOS.loadavg &&
              this.state.serverOS.loadavg["15"] !== undefined
                ? this.state.serverOS.loadavg["15"]
                : ""}
            </p>
            <p>
              <b>Load Average (60 min): </b>
              {this.state.serverOS.loadavg &&
              this.state.serverOS.loadavg["60"] !== undefined
                ? this.state.serverOS.loadavg["60"]
                : ""}
            </p>
          </div>

          <div className="divider" />

          <Row>
            <Col>
              <div className="progress-box">
                <h4>Disk</h4>
                <Circle
                  animate={true} // Boolean: Animated/Static progress
                  animationDuration="8s" // String: Length of animation
                  responsive={true} // Boolean: Make SVG adapt to parent size
                  size="80" // String: Defines the size of the circle.
                  lineWidth="25" // String: Defines the thickness of the circle's stroke.
                  progress={
                    this.state.serverDisk.total &&
                    this.state.serverDisk.available
                      ? parseInt(
                          ((this.state.serverDisk.total -
                            this.state.serverDisk.available) /
                            this.state.serverDisk.total) *
                            100, 10
                        )
                      : 0
                  } // String: Update to change the progress and percentage.
                  progressColor="#f7b924" // String: Color of "progress" portion of circle.
                  bgColor="#f3f5f2" // String: Color of "empty" portion of circle.
                  textColor="#bcbebf" // String: Color of percentage text color.
                  /* textStyle={{
                                         font: 'bold 4rem Helvetica, Arial, sans-serif' // CSSProperties: Custom styling for percentage.
                                     }}*/
                  percentSpacing={10} // Number: Adjust spacing of "%" symbol and number.
                  roundedStroke={true} // Boolean: Rounded/Flat line ends
                  showPercentage={true} // Boolean: Show/hide percentage.
                  showPercentageSymbol={true} // Boolean: Show/hide only the "%" symbol.
                />
              </div>
            </Col>
            <Col>
              <div className="progress-box">
                <h4>Details</h4>
                <p style={{ marginTop: "14px" }}>
                  Used:
                  <br />
                  <b>
                    {this.state.serverDisk.free
                      ? ServerService.convertDiskUnits(
                          this.state.serverDisk.total -
                            this.state.serverDisk.available
                        )
                      : 0}
                  </b>
                </p>
                <p>
                  Available:
                  <br />
                  <b>
                    {this.state.serverDisk.available
                      ? ServerService.convertDiskUnits(
                          this.state.serverDisk.available
                        )
                      : 0}
                  </b>
                </p>
                <p>
                  Total:
                  <br />
                  <b>
                    {this.state.serverDisk.total
                      ? ServerService.convertDiskUnits(
                          this.state.serverDisk.total
                        )
                      : 0}
                  </b>
                </p>
              </div>
            </Col>
          </Row>

          {/*
          <div className="mt-3">
            <CardTitle className="text-center">Live Statistics</CardTitle>

            <Sparklines
              data={this.state.data}
              height={44}
              limit={20}
              margin={6}
            >
              <SparklinesCurve
                length={20}
                style={{ strokeWidth: 1, stroke: "#336aff", fill: "#ffffff" }}
              />
              <SparklinesSpots
                size={2}
                style={{ stroke: "#336aff", strokeWidth: 1, fill: "#ffffff" }}
              />
              <SparklinesReferenceLine height={22} type="avg" />
            </Sparklines>
            <Row>
              <Col>
                <div className="widget-chart p-0">
                  <div className="widget-chart-content">
                    <div className="widget-numbers text-warning fsize-3">
                      43
                    </div>
                    <div className="widget-subheading pt-1">Packages</div>
                  </div>
                </div>
              </Col>
              <Col>
                <div className="widget-chart p-0">
                  <div className="widget-chart-content">
                    <div className="widget-numbers text-danger fsize-3">65</div>
                    <div className="widget-subheading pt-1">Dropped</div>
                  </div>
                </div>
              </Col>
              <Col>
                <div className="widget-chart p-0">
                  <div className="widget-chart-content">
                    <div className="widget-numbers text-success fsize-3">
                      18
                    </div>
                    <div className="widget-subheading pt-1">Invalid</div>
                  </div>
                </div>
              </Col>
            </Row>
            <div className="divider" />
            <div className="text-center mt-2 d-block">
              <Button
                outline
                className="mr-2 border-0 btn-transition"
                color="danger"
              >
                Escalate Issue
              </Button>
              <Button
                outline
                className="border-0 btn-transition"
                color="success"
              >
                Support Center
              </Button>
            </div>
          </div>
          */}
        </div>
      </Fragment>
    );
  }
}

export default ServerDetails;



// WEBPACK FOOTER //
// ./src/Layout/AppHeader/Components/TabsContent/ServerDetails.js